/*
* Handle API calls and errors
*/
import axios from 'axios'
import MessageBus from '../../utils/buses/MessageBus'
import { Color, Style } from '../../types/constants'

/**
 * Read a list of colors
 */
const getColors = async () => {
  try {
    const res = await axios.get('/constants/colors')
    const colors: Color[] = res.data.data
    return colors
  } catch (err) {
    MessageBus.sendMessage('Uh oh. Looks like something went wrong loading the list of colors.', 'error')
    console.error('getColors Error: ', err)
    return []
  }
}

/**
 * Read a list of styles
 */
const getStyles = async () => {
  try {
    const res = await axios.get('/constants/styles')
    const styles: Style[] = res.data.data
    return styles
  } catch (err) {
    MessageBus.sendMessage('Uh oh. Looks like something went wrong loading the list of styles.', 'error')
    console.error('getStyles Error: ', err)
    return []
  }
}

/**
 * Create Color
 */
const postColors = async (colors: string[]) => {
  try {
    const res = await axios.post('/constants/colors', colors)
    return res.data
  } catch (err) {
    MessageBus.sendMessage('Uh oh. Looks like something went wrong adding the list of new colors.', 'error')
    console.error('postColors Error: ', err)
    return []
  }
}

/**
 * Create Color
 */
const postStyles = async (styles: string[]) => {
  try {
    const res = await axios.post('/constants/styles', styles)
    return res.data
  } catch (err) {
    MessageBus.sendMessage('Uh oh. Looks like something went wrong adding the list of new styles.', 'error')
    console.error('postStyles Error: ', err)
    return []
  }
}

export {
  getColors,
  getStyles,
  postColors,
  postStyles
}
